import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Container, ToggleButton, ToggleButtonGroup } from '@mui/material';
import DepartmentMangement from '../components/DepartmentMangement';
import FOTAMagement from '../components/FOTAMagement';
import { PageHeaderHeight } from '../Constants';
import Header from '../components/navbar/Header';
import OrganizationMangement from '../components/OrganizationMangement';
import UserManagement from '../components/UserManagement';
import RoleManagement from '../components/RoleManagement';
import Page from '../components/Page';
import { useAuth } from '../components/customContextProviders/AuthContext';
import useFeatures from '../components/customContextProviders/FeatureContext';
import PermissionRestricted from './PermissionRestricted';

const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  flexDirection: 'row !important',
  height: PageHeaderHeight
}));

export default function Users() {
  const { sessionUserData } = useAuth();
  const feature = useFeatures();

  const [open, setOpen] = useState(false);

  const userRole = sessionUserData?.user?.userRole?.roleName;

  const [toggleTab, setToggleTab] = useState(
    userRole.toUpperCase() === 'SUPERADMIN' ? 'ORGANIZATION' : 'ROLE'
  );

  const handleToggleTab = (e, value) => {
    if (value !== null) {
      setToggleTab(value);
    }
  };

  const getManagementName = (tab) => {
    switch (tab) {
      case 'USER':
        return 'User';
      case 'ROLE':
        return 'Role';
      case 'ORGANIZATION':
        return 'Organization';
      case 'FOTA Version':
        return 'FOTA Version';
      case 'DEPARTMENT':
        return 'Department';
      default:
        return 'Management';
    }
  };

  return (
    <Page title="Users">
      <Header
        onOpenSidebar={() => setOpen(true)}
        // handleSearch={handleTripSearch}
        // handleSubmit={searchTrip}
        name={`${getManagementName(toggleTab)} Management`}
        // showSearch
      />

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <PageHeader>
          <ToggleButtonGroup
            sx={{
              '& .Mui-selected': {
                color: '#171D40 !important',
                fontWeight: '700 !important',
                backgroundColor: '#FFF !important'
              },
              '& .MuiToggleButton-root:hover': {
                color: '#171D40 !important',
                fontWeight: '700 !important',
                backgroundColor: '#FFF !important'
              },
              '& .MuiToggleButton-root': {
                backgroundColor: '#FFFFFF ',
                textAlign: 'center',
                fontFamily: 'Mulish',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 'normal',
                color: '#B0B9C7',
                padding: '8px',
                marginY: '10px'
              }
            }}
            color="primary"
            value={toggleTab}
            size="small"
            exclusive
            onChange={handleToggleTab}
            aria-label="Platform"
          >
            {userRole?.toUpperCase() === 'SUPERADMIN' && (
              <ToggleButton sx={{ minWidth: 50 }} value="ORGANIZATION">
                Organization
              </ToggleButton>
            )}
            {feature?.roleManagement?.addRole && (
              <ToggleButton sx={{ minWidth: 50 }} value="ROLE">
                Role
              </ToggleButton>
            )}
            {feature?.userManagement?.addUser && (
              <ToggleButton data-testid="user-button" sx={{ minWidth: 50 }} value="USER">
                User
              </ToggleButton>
            )}
            {userRole?.toUpperCase() === 'ADMIN' && (
              <ToggleButton sx={{ minWidth: 50 }} value="DEPARTMENT">
                Department
              </ToggleButton>
            )}
            {userRole?.toUpperCase() === 'SUPERADMIN' && (
              <ToggleButton sx={{ minWidth: 50 }} value="FOTA Version">
                FOTA Version
              </ToggleButton>
            )}
          </ToggleButtonGroup>
        </PageHeader>
        {!feature?.roleManagement?.addRole && !feature?.userManagement?.addUser && (
          <PermissionRestricted />
        )}
        {toggleTab === 'ORGANIZATION' && <OrganizationMangement />}
        {feature?.roleManagement?.addRole && toggleTab === 'ROLE' && <RoleManagement />}
        {toggleTab === 'USER' && <UserManagement />}
        {toggleTab === 'DEPARTMENT' && <DepartmentMangement />}
        {toggleTab === 'FOTA Version' && <FOTAMagement />}
      </Container>
    </Page>
  );
}
